import React, { useState } from 'react'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import MyButton from '../../../../UI/form/MyButton';
import MyModal from '../../../../UI/modal/MyModal';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import BoxSeriesForm from './BoxSeriesForm';

const BoxSeriesFormAdd = ({ packId, box }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            {
                box ? <EditIcon /> : <PlaylistAddIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Додати товари (автоматично по коробкам)'}
            disableClickOutside={true}
            content={
                <BoxSeriesForm
                    packId={packId}
                    boxBd={box}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default BoxSeriesFormAdd